import { render, staticRenderFns } from "./SubSectors.vue?vue&type=template&id=4eef1bd8&scoped=true"
import script from "./SubSectors.vue?vue&type=script&setup=true&lang=js"
export * from "./SubSectors.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef1bd8",
  null
  
)

export default component.exports